// extracted by mini-css-extract-plugin
module.exports = {"imagesGrid":"worktemplate-module--images-grid--3Gi9D","imageWrap":"worktemplate-module--image-wrap--2LGvC"};